"use client"

import { useEffect, useRef, useState } from "react"
import "./Animation.css"

const AnimatedLogo = () => {
    const svgRef = useRef(null)
    const [showAnimation, setShowAnimation] = useState(true)

    useEffect(() => {
        const svg = svgRef.current
        if (!svg) return

        // Animate the letters
        const text = svg.querySelectorAll("path.st1")
        text.forEach((path, index) => {
            if (path instanceof SVGPathElement) {
                path.style.opacity = "0"
                path.style.transition = `opacity 0.15s ease-in-out ${index * 0.15}s`

                setTimeout(() => {
                    path.style.opacity = "1"
                }, index * 200)
            }
        })

        // Animate the logo after the letters appear
        setTimeout(() => {
            const leftHalf = svg.querySelector("path.st2.left-half")
            const rightHalf = svg.querySelector("path.st2.right-half")

            if (leftHalf && rightHalf) {
                leftHalf.style.opacity = "0"
                rightHalf.style.opacity = "0"
                leftHalf.style.transition = "opacity 0.7s ease-in"
                rightHalf.style.transition = "opacity 0.7s ease-in"

                setTimeout(() => {
                    leftHalf.style.opacity = "1"
                    leftHalf.style.fill = "#F24535" // Red
                    rightHalf.style.opacity = "1"
                    rightHalf.style.fill = "#F24535" // Blue
                }, 1300) // Paint after 1.3s
            }
        }, text.length * 200)

        // Fade out the animation after 3 seconds
        setTimeout(() => {
            const container = svg.parentElement
            if (container) {
                container.style.transition = "opacity 0.5s ease-in-out"
                container.style.opacity = "0"

                setTimeout(() => {
                    setShowAnimation(false)
                }, 500)
            }
        }, 4000) // Disappear after 4s
    }, [])

    return (
        <div className="animation-container">
            <svg
                ref={svgRef}
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 500 500"
                className="animated-logo"
            >
                <defs>
                    <clipPath id="leftHalf">
                        <rect x="0" y="0" width="250" height="500" />
                    </clipPath>
                    <clipPath id="rightHalf">
                        <rect x="250" y="0" width="250" height="500" />
                    </clipPath>
                </defs>
                <rect width="500" height="500" fill="#121212" />
                <g>
                    <path
                        className="st1"
                        d="M60.7,294.9L60.7,294.9c0-10.3,7.8-18.3,18.4-18.3c7.1,0,11.7,3,14.8,7.3l-7.3,5.6c-2-2.5-4.3-4.1-7.6-4.1 c-4.9,0-8.3,4.1-8.3,9.2v0.1c0,5.2,3.4,9.3,8.3,9.3c3.6,0,5.8-1.7,7.9-4.2l7.3,5.2c-3.3,4.5-7.7,7.9-15.5,7.9 C68.7,312.9,60.7,305.3,60.7,294.9z"
                    />
                    <path
                        className="st1"
                        d="M98.1,294.9L98.1,294.9c0-10.1,8.1-18.3,18.9-18.3s18.8,8,18.8,18.1v0.1c0,10-8.1,18.2-18.9,18.2 S98.1,304.9,98.1,294.9z M125.9,294.9L125.9,294.9c0-5.1-3.6-9.5-9-9.5c-5.3,0-8.8,4.3-8.8,9.3v0.1c0,5,3.6,9.4,8.9,9.4 C122.3,304.2,125.9,299.9,125.9,294.9z"
                    />
                    <path className="st1" d="M142.8,277.3h9l14.4,18.5v-18.5h9.6v34.9h-8.5l-14.9-19.2v19.2h-9.6V277.3z" />
                    <path className="st1" d="M192.5,285.8H182v-8.5h30.6v8.5h-10.5v26.4h-9.7V285.8z" />
                    <path
                        className="st1"
                        d="M226.5,277h9.3l14.9,35.2h-10.4l-2.5-6.2h-13.5l-2.5,6.2h-10.2L226.5,277z M235,298.4l-3.9-9.9l-3.9,9.9H235z"
                    />
                    <path
                        className="st1"
                        d="M252.6,294.9L252.6,294.9c0-10.3,7.8-18.3,18.4-18.3c7.1,0,11.7,3,14.8,7.3l-7.3,5.6c-2-2.5-4.3-4.1-7.6-4.1 c-4.9,0-8.3,4.1-8.3,9.2v0.1c0,5.2,3.4,9.3,8.3,9.3c3.6,0,5.8-1.7,7.9-4.2l7.3,5.2c-3.3,4.5-7.7,7.9-15.5,7.9 C260.7,312.9,252.6,305.3,252.6,294.9z"
                    />
                    <path className="st1" d="M300.8,285.8h-10.5v-8.5h30.6v8.5h-10.5v26.4h-9.7V285.8z" />
                    <path
                        className="st1"
                        d="M334.8,277h9.3l14.9,35.2h-10.4L346,306h-13.5l-2.5,6.2h-10.2L334.8,277z M343.2,298.4l-3.9-9.9l-3.9,9.9 H343.2z"
                    />
                    <path
                        className="st1"
                        d="M364.4,277.3h10.2l8.3,13.5l8.3-13.5h10.2v34.9h-9.6v-20.1l-8.9,13.7h-0.2l-8.9-13.6v20h-9.5V277.3z"
                    />
                    <path className="st1" d="M409.7,277.3h28.1v8.2h-18.5v5.3H436v7.6h-16.8v5.5H438v8.2h-28.3V277.3z" />
                </g>
                <g>
                    <path
                        className="st2 left-half"
                        clipPath="url(#leftHalf)"
                        d="M286.6,172.8c-17.7,0-32,10.5-37.3,25.2c-5.3-14.7-19.6-25.2-37.3-25.2c-22.6,0-39.4,16.9-39.4,37.9v0.2 c0,21.1,17,38.1,39.6,38.1c17.7,0,31.8-10.3,37.1-24.9c5.3,14.6,19.4,24.9,37.1,24.9C309,249.1,326,232,326,211v-0.2 C326,189.7,309.3,172.8,286.6,172.8z M305.3,211.2c0,10.6-7.4,19.6-18.7,19.6c-7,0-12.7-3.7-15.9-9.1h-20.6h-1.7h-20.6 c-3.2,5.4-8.8,9.1-15.9,9.1c-11.2,0-18.7-9-18.7-19.6V211c0-10.6,7.6-19.8,18.9-19.8c7,0,12.5,3.5,15.6,8.8h20.8h1.4h20.8 c3.1-5.3,8.7-8.8,15.6-8.8c11.2,0,18.9,9.2,18.9,19.8V211.2z"
                    />
                    <path
                        className="st2 right-half"
                        clipPath="url(#rightHalf)"
                        d="M286.6,172.8c-17.7,0-32,10.5-37.3,25.2c-5.3-14.7-19.6-25.2-37.3-25.2c-22.6,0-39.4,16.9-39.4,37.9v0.2 c0,21.1,17,38.1,39.6,38.1c17.7,0,31.8-10.3,37.1-24.9c5.3,14.6,19.4,24.9,37.1,24.9C309,249.1,326,232,326,211v-0.2 C326,189.7,309.3,172.8,286.6,172.8z M305.3,211.2c0,10.6-7.4,19.6-18.7,19.6c-7,0-12.7-3.7-15.9-9.1h-20.6h-1.7h-20.6 c-3.2,5.4-8.8,9.1-15.9,9.1c-11.2,0-18.7-9-18.7-19.6V211c0-10.6,7.6-19.8,18.9-19.8c7,0,12.5,3.5,15.6,8.8h20.8h1.4h20.8 c3.1-5.3,8.7-8.8,15.6-8.8c11.2,0,18.9,9.2,18.9,19.8V211.2z"
                    />
                </g>
            </svg>
        </div>
    )
}

export default AnimatedLogo

